import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/modal-Sucesso.jpg'
import _imports_1 from '@/assets/images/Sala_de_espera.svg'


const _hoisted_1 = {
  id: "modal-success-validation-DNS",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "modalSuccessValidationDNS",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-footer" }
const _hoisted_5 = { class: "d-flex justify-content-end col-12 col-md-4" }
const _hoisted_6 = { class: "d-flex justify-content-end col-12 col-md-4" }
const _hoisted_7 = { class: "modal-content" }
const _hoisted_8 = { class: "modal-footer" }
const _hoisted_9 = { class: "d-flex justify-content-end col-12 col-md-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"modal-header\"><p class=\"w-100 text-start fs-5 fw-600 m-0\">Tudo Certo!</p><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button></div><div class=\"modal-body\"><div class=\"mb-5 text-center\"><img width=\"210px\" src=\"" + _imports_0 + "\" alt=\"waiting-room\"></div><div class=\"text-start\"><p class=\"w-100 text-start fs-6 fw-600 m-0\"> Seu domínio foi validado com sucesso! </p><p class=\"w-100 text-start fs-6 m-0\"> Deseja instalar seu certificado agora? </p></div></div>", 2)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "btn btn-secondary col-12",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeModal && _ctx.changeModal(...args)))
            }, _cache[3] || (_cache[3] = [
              _createElementVNode("span", null, "Instalar mais tarde", -1)
            ]))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "btn btn-primary col-12",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.navidateToGuide && _ctx.navidateToGuide(...args)))
            }, _cache[4] || (_cache[4] = [
              _createElementVNode("span", null, "Instalar Agora", -1)
            ]))
          ])
        ])
      ], 512), [
        [_vShow, _ctx.deafultModal]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_7, [
        _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"modal-header\"><p class=\"w-100 text-start fs-5 fw-600 m-0\">Sem tempo agora?</p><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button></div><div class=\"modal-body\"><div class=\"mb-5 text-center\"><img width=\"210px\" src=\"" + _imports_1 + "\" alt=\"Menina com xícara de café com um desenho de coreção\"></div><div class=\"text-start\"><p class=\"w-100 text-start fs-6 m-0\"> Sem problemas! Já te enviamos um e-mail com as instruções para você instalar mais tarde! </p></div></div>", 2)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "btn btn-primary col-12",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hideModal && _ctx.hideModal(...args)))
            }, _cache[6] || (_cache[6] = [
              _createElementVNode("span", null, "Fechar", -1)
            ]))
          ])
        ])
      ], 512), [
        [_vShow, !_ctx.deafultModal]
      ])
    ])
  ]))
}